import { render, staticRenderFns } from "./Archives.vue?vue&type=template&id=5d35381c&"
import script from "./Archives.vue?vue&type=script&lang=js&"
export * from "./Archives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports